export default __webpack_public_path__ + "static/media/58.c0138d87.jpg";